export const getConfiguration = async (referrerID, gameID, sessionID) => {
  let json = null;

  try {
    //gameID = 0; // I think is ok. Used because of the list descriptors.

    // console.error(`xxxxxxxxxxxxx :${process.env.REACT_APP_BASE_URL}`);
    // 
    const response = await fetch(`${process.env.REACT_APP_BASE_URL}/api/configuration/${referrerID}/${gameID}?sessionid=${sessionID}`);
    json = await response.json();
  } catch (err) {
    console.log("Exception: " + err);
  }

  return json;
};

export const postConfiguration = async (configuration) => {

  //(async () => {

    const rawResponse = await fetch(`${process.env.REACT_APP_BASE_URL}/api/configuration`, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(configuration)
    });
  
    const content = await rawResponse.json();
    return content;

//    console.log(content);
  //})();

}


//   let json = null;

//   try {
//     const response = await fetch(`${process.env.REACT_APP_BASE_URL}/api/configuration/${referrerID}/${gameID}?sessionid=${sessionID}`, );
//     json = await response.json();
//   } catch (err) {
//     console.log("Exception: " + err);
//   }

//   return json;
// };